import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';


export function AddCategoryData(store, catObj, successFunc) {

    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Post('eventcategory/json').ExtraData(catObj).AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
}

export function GetCategoryData(store,successFunc) {

    let loader = { isLoader: true, containerId: 'testpnk', size: 'small' };
    return PnkAjax(store).Get('eventcategory/json').AttachLoader(loader).AddHeader({ 'x-access-token': localStorage.getItem('current_user_login_token') }).OnSuccess(successFunc).Do();
}
